import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { buffer, catchError, map, Observable, Subject, Subscription, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiservicesService {
  public baseUrl: any = environment.api_url;
  public jwtToken: string = '';
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: '',
    }),
  };
 


  constructor(private http: HttpClient, private cookieService: CookieService) { }

 
  public getHttpData(url: any): Observable<any> {
    return this.http.get(url);
  }
  

  public getHttpDataWithoutBaseUrl(url: any): Observable<any> {
    return this.http.get<any>(url).pipe(
      catchError((error) => { 
        console.log('error --->', error);
        return throwError(() => new Error(error));
      })
    );;
  }

 

 

  public getHttpDataPostWithoutBaseUrl (url: any,body:any): Observable<any> {
    return this.http.post<any>(url, body).pipe(
      catchError((error) => {
        // this.openSnackBar();
            console.log("this is login error",error);
            
        return throwError(()=>error.error);
      })
    )
  }


 

 


  httpViaPost(endpoint: any, jsonData: any): Observable<any> {
    // console.log("{{}{}{",jsonData);

    /* set common header */
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': this.jwtToken
      })
    };
    return this.http.post(this.baseUrl + endpoint, jsonData, httpOptions)

  }


 


}